var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageData.contents[0].description)?_c('pre',{staticClass:"pageDescription text-justify"},[_vm._v(_vm._s(_vm.pageData.contents[0].description))]):_vm._e(),_vm._l((_vm.pageData.childEntries.rows),function(articleThumb){return _c('ArticleCard',{key:articleThumb.id,attrs:{"articleThumb":articleThumb}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }